var _defs, _polygon, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _polygon2, _polygon3, _polygon4, _polygon5, _path, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarieraTermicaWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ba5f89af-ea2a-4c03-a82a-bb3721f8ea98",
    "data-name": "bariera_termica",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 174.56 201.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a7360429-a1d5-4e39-a2cb-a8bd6776cb01,.a82977a9-d6c2-489a-99d2-76498df60113,.b82135f2-7588-44d5-ac0d-b5b08c6d60ef{fill:#fff;}.b82135f2-7588-44d5-ac0d-b5b08c6d60ef,.bed1665a-be09-4b22-b283-90d169d720a7{fill-rule:evenodd;}.aea5edd0-b54b-4c16-933a-d4efa180a528,.bed1665a-be09-4b22-b283-90d169d720a7,.e0bb8aa6-c6ae-4c7e-b63c-952da6b623ac,.e37277ab-7e55-415a-97d4-e40786282946,.e8b11e3a-8443-4505-a64e-fa027906d205{fill:none;}.a7360429-a1d5-4e39-a2cb-a8bd6776cb01,.a82977a9-d6c2-489a-99d2-76498df60113,.aea5edd0-b54b-4c16-933a-d4efa180a528,.bed1665a-be09-4b22-b283-90d169d720a7,.e0bb8aa6-c6ae-4c7e-b63c-952da6b623ac,.e37277ab-7e55-415a-97d4-e40786282946,.e8b11e3a-8443-4505-a64e-fa027906d205{stroke:#fff;stroke-miterlimit:10;}.a82977a9-d6c2-489a-99d2-76498df60113,.e37277ab-7e55-415a-97d4-e40786282946{stroke-width:8px;}.e0bb8aa6-c6ae-4c7e-b63c-952da6b623ac{stroke-width:5px;}.aea5edd0-b54b-4c16-933a-d4efa180a528{stroke-width:3px;}.e8b11e3a-8443-4505-a64e-fa027906d205{stroke-width:10px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bariera_termica_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b82135f2-7588-44d5-ac0d-b5b08c6d60ef",
    points: "64.56 136.4 29.2 101.04 64.56 65.69 64.56 101.04 64.56 136.4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "e37277ab-7e55-415a-97d4-e40786282946",
    x1: 64.56,
    y1: 101.04,
    x2: 20.06,
    y2: 56.54
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "e0bb8aa6-c6ae-4c7e-b63c-952da6b623ac",
    x1: 37.56,
    y1: 73.79,
    x2: 37.56,
    y2: 48.29
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "aea5edd0-b54b-4c16-933a-d4efa180a528",
    x1: 37.06,
    y1: 59.54,
    x2: 29.56,
    y2: 52.04
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "aea5edd0-b54b-4c16-933a-d4efa180a528",
    x1: 38.56,
    y1: 59.54,
    x2: 46.06,
    y2: 52.04
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "e0bb8aa6-c6ae-4c7e-b63c-952da6b623ac",
    x1: 38.06,
    y1: 74.79,
    x2: 12.56,
    y2: 74.79
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "aea5edd0-b54b-4c16-933a-d4efa180a528",
    x1: 23.81,
    y1: 75.29,
    x2: 16.31,
    y2: 82.79
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "aea5edd0-b54b-4c16-933a-d4efa180a528",
    x1: 23.81,
    y1: 73.79,
    x2: 16.31,
    y2: 66.29
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "e0bb8aa6-c6ae-4c7e-b63c-952da6b623ac",
    x1: 5.56,
    y1: 57.54,
    x2: 20.56,
    y2: 57.54
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "aea5edd0-b54b-4c16-933a-d4efa180a528",
    x1: 6.06,
    y1: 57.54,
    x2: 1.06,
    y2: 62.54
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "aea5edd0-b54b-4c16-933a-d4efa180a528",
    x1: 6.06,
    y1: 57.54,
    x2: 1.06,
    y2: 52.54
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "e0bb8aa6-c6ae-4c7e-b63c-952da6b623ac",
    x1: 20.81,
    y1: 42.29,
    x2: 20.81,
    y2: 57.29
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "aea5edd0-b54b-4c16-933a-d4efa180a528",
    x1: 20.81,
    y1: 42.79,
    x2: 15.81,
    y2: 37.79
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "aea5edd0-b54b-4c16-933a-d4efa180a528",
    x1: 20.81,
    y1: 42.79,
    x2: 25.81,
    y2: 37.79
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "e37277ab-7e55-415a-97d4-e40786282946",
    x1: 64.56,
    y1: 100.04,
    x2: 20.06,
    y2: 144.54
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "e0bb8aa6-c6ae-4c7e-b63c-952da6b623ac",
    x1: 37.56,
    y1: 127.29,
    x2: 37.56,
    y2: 152.79
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "aea5edd0-b54b-4c16-933a-d4efa180a528",
    x1: 37.06,
    y1: 141.54,
    x2: 29.56,
    y2: 149.04
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "aea5edd0-b54b-4c16-933a-d4efa180a528",
    x1: 38.56,
    y1: 141.54,
    x2: 46.06,
    y2: 149.04
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "e0bb8aa6-c6ae-4c7e-b63c-952da6b623ac",
    x1: 38.06,
    y1: 126.29,
    x2: 12.56,
    y2: 126.29
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "aea5edd0-b54b-4c16-933a-d4efa180a528",
    x1: 23.81,
    y1: 125.79,
    x2: 16.31,
    y2: 118.29
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "aea5edd0-b54b-4c16-933a-d4efa180a528",
    x1: 23.81,
    y1: 127.29,
    x2: 16.31,
    y2: 134.79
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "e0bb8aa6-c6ae-4c7e-b63c-952da6b623ac",
    x1: 5.56,
    y1: 143.54,
    x2: 20.56,
    y2: 143.54
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "aea5edd0-b54b-4c16-933a-d4efa180a528",
    x1: 6.06,
    y1: 143.54,
    x2: 1.06,
    y2: 138.54
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "aea5edd0-b54b-4c16-933a-d4efa180a528",
    x1: 6.06,
    y1: 143.54,
    x2: 1.06,
    y2: 148.54
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "e0bb8aa6-c6ae-4c7e-b63c-952da6b623ac",
    x1: 20.81,
    y1: 158.79,
    x2: 20.81,
    y2: 143.79
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "aea5edd0-b54b-4c16-933a-d4efa180a528",
    x1: 20.81,
    y1: 158.29,
    x2: 15.81,
    y2: 163.29
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "aea5edd0-b54b-4c16-933a-d4efa180a528",
    x1: 20.81,
    y1: 158.29,
    x2: 25.81,
    y2: 163.29
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "e0bb8aa6-c6ae-4c7e-b63c-952da6b623ac",
    x1: 33.06,
    y1: 101.54,
    x2: 26.06,
    y2: 94.54
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "e0bb8aa6-c6ae-4c7e-b63c-952da6b623ac",
    x1: 33.06,
    y1: 100.54,
    x2: 26.06,
    y2: 107.54
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "e8b11e3a-8443-4505-a64e-fa027906d205",
    x1: 64.56,
    y1: 200.54,
    x2: 64.56,
    y2: 0.54
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "e8b11e3a-8443-4505-a64e-fa027906d205",
    x1: 104.56,
    y1: 200.54,
    x2: 104.56,
    y2: 0.54
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "bed1665a-be09-4b22-b283-90d169d720a7",
    points: "64.35 177.89 64.35 200.54 85.12 200.54 103.71 189.81 103.71 155.17 64.35 177.89"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "bed1665a-be09-4b22-b283-90d169d720a7",
    points: "64.35 121.89 64.35 156.53 103.71 133.81 103.71 99.17 64.35 121.89"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "bed1665a-be09-4b22-b283-90d169d720a7",
    points: "64.35 67.89 64.35 102.53 103.71 79.81 103.71 45.17 64.35 67.89"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "bed1665a-be09-4b22-b283-90d169d720a7",
    points: "84.08 0.5 64.35 11.89 64.35 46.53 103.71 23.81 103.71 0.5 84.08 0.5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a7360429-a1d5-4e39-a2cb-a8bd6776cb01",
    d: "M125,65a36.13,36.13,0,0,0-4.79.33v69.34A36.13,36.13,0,0,0,125,135a35,35,0,0,0,0-70Z",
    transform: "translate(-15.44 0.54)"
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "a82977a9-d6c2-489a-99d2-76498df60113",
    x1: 109.56,
    y1: 100.54,
    x2: 174.56,
    y2: 100.54
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "a82977a9-d6c2-489a-99d2-76498df60113",
    x1: 109.02,
    y1: 101.16,
    x2: 170.1,
    y2: 78.93
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "a82977a9-d6c2-489a-99d2-76498df60113",
    x1: 109.66,
    y1: 100.93,
    x2: 159.46,
    y2: 59.15
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "a82977a9-d6c2-489a-99d2-76498df60113",
    x1: 109.31,
    y1: 100.19,
    x2: 141.81,
    y2: 43.9
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "a82977a9-d6c2-489a-99d2-76498df60113",
    x1: 108.92,
    y1: 100.05,
    x2: 120.2,
    y2: 36.04
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "a82977a9-d6c2-489a-99d2-76498df60113",
    x1: 109.56,
    y1: 100.65,
    x2: 174.56,
    y2: 100.65
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "a82977a9-d6c2-489a-99d2-76498df60113",
    x1: 109.02,
    y1: 100.04,
    x2: 170.1,
    y2: 122.27
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "a82977a9-d6c2-489a-99d2-76498df60113",
    x1: 109.66,
    y1: 100.26,
    x2: 159.46,
    y2: 142.04
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "a82977a9-d6c2-489a-99d2-76498df60113",
    x1: 109.31,
    y1: 101.01,
    x2: 141.81,
    y2: 157.3
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "a82977a9-d6c2-489a-99d2-76498df60113",
    x1: 108.92,
    y1: 101.15,
    x2: 120.2,
    y2: 165.16
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarieraTermicaWhite);
export default __webpack_public_path__ + "static/media/bariera_termica_white.d2b36a4c176a1bcd493957d6a784c56a.svg";
export { ForwardRef as ReactComponent };